let currentTime = 0;
let timerReference = null;

export default {
	state: {
		watchers: [],
		paused: true,
	},
	actions: {
		startClock(context) {
			currentTime = performance.now();
			context.dispatch("unpauseTimers");
			context.dispatch("clockIteration");

			context.state.watchers.forEach((timer, index) => {
				context.commit("updateTimerActionTime", {
					actionTime: currentTime + timer.timeRemaining,
					timerIndex: index,
				});
			});
		},
		pauseTimers(context) {
			for (let timerIndex = 0; timerIndex < context.state.watchers.length; timerIndex += 1) {
				context.commit("updateTimeRemaining", {
					index: timerIndex,
				});
			}
			context.commit("pause");
		},
		unpauseTimers(context) {
			context.state.watchers.forEach((timer, index) => {
				context.commit("updateTimerActionTime", {
					actionTime: currentTime + timer.timeRemaining,
					timerIndex: index,
				});
			});
			context.commit("unpause");
			context.dispatch("clockIteration");
		},
		stopClock(context) {
			context.commit("pause");
			context.commit("removeAllTimers");
		},
		clockIteration(context) {
			timerReference = requestAnimationFrame((timestamp) => {
				currentTime = timestamp;
				context.dispatch("clockIteration");
				if (!context.state.paused) {
					context.dispatch("checkTimers", { timestamp });
				}
			});
		},
		checkTimers(context) {
			for (let timerIndex = 0; timerIndex < context.state.watchers.length; timerIndex += 1) {
				context.dispatch("checkTimer", {
					timer: context.state.watchers[timerIndex],
					index: timerIndex,
				});
			}
		},
		checkTimer(context, payload) {
			if (currentTime > payload.timer.actionTime) {
				context.dispatch("completeTimer", payload);
			}
		},
		completeTimer(context, payload) {
			const timerData = {
				duration: payload.timer.duration,
				repeats: payload.timer.repeat,
			};

			const timerPayload = Object.assign({ timer: timerData }, payload.timer.payload);

			context.commit("updateTimeRemaining", {
				index: context.getters.timerIndexByRef(payload.timer.ref),
			});

			payload.timer.action(timerPayload);

			if (payload.timer.repeat <= 1) {
				context.dispatch("removeTimer", { ref: payload.timer.ref });
			} else {
				context.commit("decrementTimerRepeatCount", { timerIndex: payload.index });
				context.commit("updateTimerActionTime", {
					actionTime: currentTime + payload.timer.duration,
					timerIndex: payload.index,
				});
			}
		},
		removeTimer(context, payload) {
			const index = context.getters.timerIndexByRef(payload.ref);
			context.commit("removeTimerByIndex", {
				index,
			});
		},
	},
	mutations: {
		addTimer(state, payload) {
			const timer = {
				duration: payload.duration,
				ref: payload.ref || state.watchers.length + 1,
				timeRemaining: payload.duration,
				actionTime: currentTime + payload.duration,
				action: payload.action,
				payload: payload.payload || {},
				repeat: payload.repeat || 0,
			};

			if (typeof timer.action === "function") {
				state.watchers.push(timer);
			}
		},
		updateTimerActionTime(state, payload) {
			state.watchers[payload.timerIndex].actionTime = payload.actionTime;
		},
		removeTimerByIndex(state, payload) {
			state.watchers.splice(payload.index, 1);
		},
		removeAllTimers(state) {
			state.watchers.splice(0, state.watchers.length);
		},
		updateTimeRemaining(state, payload) {
			const timer = state.watchers[payload.index];
			timer.timeRemaining = Math.max(0, timer.actionTime - currentTime);
		},
		decrementTimerRepeatCount(state, payload) {
			state.watchers[payload.timerIndex].repeat -= 1;
		},
		pause(state) {
			state.paused = true;
			cancelAnimationFrame(timerReference);
		},
		unpause(state) {
			state.paused = false;
		},
	},
	getters: {
		timerExists(state, getters) {
			return ref => typeof getters.timerByRef(ref) !== "undefined";
		},
		timerByRef(state) {
			return ref => state.watchers.find(timer => timer.ref === ref);
		},
		timerIndexByRef(state) {
			return ref => state.watchers.findIndex(timer => timer.ref === ref);
		},
		timerPercent() {
			return timer => Math.round(timer.actionTime - currentTime) / timer.duration;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/timer.js